import BufferTabView from 'buffers/BufferTabView';
import {Sequence} from 'components/Sequence';
import ProteinAlignmentTabState from 'molbio/proteins/alignments/ProteinAlignmentTabState';
import Protein from 'molbio/proteins/Protein';
import PolymerMapTabState from 'molbio/tabstates/PolymerMapTabState';

// Oddly, ProteinAlignmentTabState does not extend from PolymerMapTabState. Possibly an oversight.
export type PolymerBufferTabState = PolymerMapTabState<Sequence | Protein> | ProteinAlignmentTabState;

// Used for both proteins and sequences
abstract class PolymerBufferTabView<M extends PolymerBufferTabState> extends BufferTabView<M> {
  abstract addPolymersForSearch(): void;
  abstract removePolymersForSearch(): void;

  remove(): this {
    super.remove();
    this.removePolymersForSearch();
    return this;
  }

  render(): this {
    super.render();
    this.addPolymersForSearch();
    return this;
  }
}

export default PolymerBufferTabView;
